import { add, format } from 'date-fns';

type TranscriptMessage = {
  speaker: string;
  start: number;
  end: number;
  text: string;
};

export const getDurationFromTranscript = (
  messages: TranscriptMessage[],
  startDateTime: string
): {
  duration: string;
  startTime: string;
  endTime: string;
  timeRange: string;
} => {
  if (!messages || messages.length === 0)
    return { duration: '0 mins', startTime: '', endTime: '', timeRange: '' };

  const firstMessage = messages[0];
  const lastMessage = messages[messages.length - 1];

  const durationMs = lastMessage.end - firstMessage.start;
  const minutes = Math.floor(durationMs / 60000);

  // Extract time from startDateTime (format: "2025-04-23T13:00:00Z")
  const startTime = format(new Date(startDateTime), 'HH:mm');
  const endTime = format(add(new Date(startDateTime), { minutes }), 'HH:mm');

  return {
    duration: `${minutes} min${minutes !== 1 ? 's' : ''}`,
    startTime,
    endTime,
    timeRange: `${startTime} - ${endTime}`
  };
};
